export enum QuickbooksUpdateStatusEnum {
  SENT = 'sent',
  PENDING = 'pending',
  ERROR = 'error',
}
